/**
 * Environment-to-endpoints map for modules.
 * Modules call getEndpointsForEnv(env) to get API base URLs for the given environment.
 * Values align with host app .env.development, .env.staging, .env.preprod, .env.production.
 */

export type ModuleApiEnv = "development" | "staging" | "preprod" | "production";

export type ApiEndpointsMap = Record<string, string>;

const ENV_ENDPOINTS: Record<ModuleApiEnv, ApiEndpointsMap> = {
  development: {
    learnGateway: "https://gatewaystaging.devinfinitylearn.in",
    comService: "https://comservice.devinfinitylearn.in",
    oms: "https://omsstagingapi.devinfinitylearn.in",
    oneOms: "https://oneomsstaging.devinfinitylearn.in",
    cms: "https://cmsapi.devinfinitylearn.in",
    oneCms: "https://onecmsstaging.devinfinitylearn.in",
    assetRendering: "https://d225lw13gwy30y.cloudfront.net/v1.3",
    masterData: "https://mdsstaging.devinfinitylearn.in/stage",
    tenantManagement: "https://tenantmanagement.devinfinitylearn.in",
    newQB: "https://newqbapistage.devinfinitylearn.in",
    assessment: "https://asmstagingapi.devinfinitylearn.in/v2",
    oneAsm: "https://oneasmstaging.devinfinitylearn.in",
    doubts: "https://dcapi-staging.devinfinitylearn.in/apis",
    doubtsDCAPI: "https://dcapi-staging.devinfinitylearn.in/apis",
    doubtsAI: "https://doubtsai-staging.devinfinitylearn.in/apis",
    doubtsQB: "https://recsys.devinfinitylearn.in/api/v1",
    wizklub: "https://dev.wizklub.com",
    peekmind: "https://staging.dqtcqmf0ijz09.amplifyapp.com",
    peekMindReport:
      "https://azwd5vdqkb.execute-api.ap-south-1.amazonaws.com/qa/cqtest",
    peekmindOnResume: "https://learnstagingapi.devinfinitylearn.in",
    newPeekmindToken: "https://tkry7yengl.execute-api.ap-south-1.amazonaws.com",
    newPeekmindQuiz: "https://pfd8tl0ry2.execute-api.ap-south-1.amazonaws.com",
    learn: "https://learnstaginglambda.devinfinitylearn.in",
    liveclass: "https://lcstudentstaginglambda.devinfinitylearn.in",
    liveclassSocket: "https://livestagingapi.devinfinitylearn.in",
    eos: "https://stageeosapi.devinfinitylearn.in",
    oneApp: "https://oneappstaginglambda.devinfinitylearn.in",
    aina: "https://aiagentsdev.devinfinitylearn.in/api/v1",
    uam: "https://stagingapi.devinfinitylearn.in",
    myActivity: "https://myactivitystgapi.devinfinitylearn.in",
    dataReport: "https://analytics-staging.devinfinitylearn.in",
    search: "https://searchapis.devinfinitylearn.in",
    selflearn: "https://selflearnv2stgapi.devinfinitylearn.in",
    selflearnWebSocket: "wss://selflearnv2stgapi.devinfinitylearn.in",
    lsqManagement: "https://lsqmanagement.devinfinitylearn.in",
    lsqService: "https://lsqservice.infinitylearn.com/api/v1",
    testlms: "https://testlms.ilteach.com",
  },
  staging: {
    learnGateway: "https://gatewaystaging.devinfinitylearn.in",
    comService: "https://comservice.devinfinitylearn.in",
    oms: "https://omsstagingapi.devinfinitylearn.in",
    oneOms: "https://oneomsstaging.devinfinitylearn.in",
    cms: "https://cmsapi.devinfinitylearn.in",
    oneCms: "https://onecmsstaging.devinfinitylearn.in",
    assetRendering: "https://d225lw13gwy30y.cloudfront.net/v1.3",
    masterData: "https://mdsstaging.devinfinitylearn.in/stage",
    tenantManagement: "https://tenantmanagement.devinfinitylearn.in",
    newQB: "https://newqbapistage.devinfinitylearn.in",
    assessment: "https://asmstagingapi.devinfinitylearn.in/v2",
    oneAsm: "https://oneasmstaging.devinfinitylearn.in",
    doubts: "https://dcapi-staging.devinfinitylearn.in/apis",
    doubtsDCAPI: "https://dcapi-staging.devinfinitylearn.in/apis",
    doubtsAI: "https://doubtsai-staging.devinfinitylearn.in/apis",
    doubtsQB: "https://recsys.devinfinitylearn.in/api/v1",
    wizklub: "https://dev.wizklub.com",
    peekmind: "https://staging.dqtcqmf0ijz09.amplifyapp.com",
    peekMindReport:
      "https://azwd5vdqkb.execute-api.ap-south-1.amazonaws.com/qa/cqtest",
    peekmindOnResume: "https://learnstagingapi.devinfinitylearn.in",
    newPeekmindToken: "https://tkry7yengl.execute-api.ap-south-1.amazonaws.com",
    newPeekmindQuiz: "https://pfd8tl0ry2.execute-api.ap-south-1.amazonaws.com",
    learn: "https://learnstaginglambda.devinfinitylearn.in",
    liveclass: "https://lcstudentstaginglambda.devinfinitylearn.in",
    liveclassSocket: "https://livestagingapi.devinfinitylearn.in",
    newasm: "https://newasmstageapi.devinfinitylearn.in/",
    eos: "https://stageeosapi.devinfinitylearn.in",
    oneApp: "https://oneappstaginglambda.devinfinitylearn.in",
    aina: "https://aiagentsdev.devinfinitylearn.in/api/v1",
    uam: "https://stagingapi.devinfinitylearn.in",
    myActivity: "https://myactivitystgapi.devinfinitylearn.in",
    dataReport: "https://analytics-staging.devinfinitylearn.in",
    search: "https://searchapis.devinfinitylearn.in",
    selflearn: "https://selflearnv2stgapi.devinfinitylearn.in",
    selflearnWebSocket: "wss://selflearnv2stgapi.devinfinitylearn.in",
    lsqManagement: "https://lsqmanagement.devinfinitylearn.in",
    lsqService: "https://lsqservice.infinitylearn.com/api/v1",
    testlms: "https://testlms.ilteach.com",
  },
  preprod: {
    learnGateway: "https://gatewayapi.devinfinitylearn.in",
    comService: "https://comservice.devinfinitylearn.in",
    oms: "https://omsapi.devinfinitylearn.in",
    oneOms: "https://oneomspreprod.devinfinitylearn.in",
    cms: "https://cmspreprodapi.devinfinitylearn.in",
    oneCms: "https://onecmspreprod.devinfinitylearn.in",
    assetRendering:
      "https://assetrenderingservicepreprod.devinfinitylearn.in/v1.3",
    masterData: "https://mdspreprod.devinfinitylearn.in/preprod",
    tenantManagement: "https://tenantmgmtpreprod.devinfinitylearn.in",
    newQB: "https://newqbapi.devinfinitylearn.in",
    assessment: "https://asmpreprodapi.devinfinitylearn.in/v2",
    oneAsm: "https://oneasmapi.devinfinitylearn.in",
    doubts: "https://dcapi.devinfinitylearn.in/apis",
    doubtsDCAPI: "https://dcapi.devinfinitylearn.in/apis",
    doubtsAI: "https://doubtsai.devinfinitylearn.in/apis",
    doubtsQB: "https://recsys.infinitylearn.com/api/v1",
    wizklub: "https://dev.wizklub.com",
    peekmind: "https://staging.dqtcqmf0ijz09.amplifyapp.com",
    peekMindReport:
      "https://azwd5vdqkb.execute-api.ap-south-1.amazonaws.com/qa/cqtest",
    peekmindOnResume: "https://learnapi.devinfinitylearn.in",
    newPeekmindToken: "https://tkry7yengl.execute-api.ap-south-1.amazonaws.com",
    newPeekmindQuiz: "https://pfd8tl0ry2.execute-api.ap-south-1.amazonaws.com",
    learn: "https://learnpreprodlambda.devinfinitylearn.in",
    liveclass:
      "https://u7vrkapm9i.execute-api.ap-south-1.amazonaws.com/preprod",
    liveclassSocket: "https://lcwebsocketpreprod.devinfinitylearn.in",
    newasm: "https://newasmapi.devinfinitylearn.in/",
    eos: "https://eosapi.devinfinitylearn.in",
    oneApp: "https://oneapp.devinfinitylearn.in",
    aina: "https://aiagentsdev.devinfinitylearn.in/api/v1",
    uam: "https://api.devinfinitylearn.in",
    myActivity: "https://myactivity.devinfinitylearn.in",
    dataReport: "https://analytics-preprod.devinfinitylearn.in",
    search: "https://searchapis.devinfinitylearn.in",
    selflearn: "https://selflearnv2api.devinfinitylearn.in",
    selflearnWebSocket: "wss://selflearnv2api.devinfinitylearn.in",
    lsqManagement: "https://lsqmanagementpreprod.devinfinitylearn.in",
    lsqService: "https://lsqservice.infinitylearn.com/api/v1",
    testlms: "https://testlms.ilteach.com",
  },
  production: {
    learnGateway: "https://gatewayapilearn.infinitylearn.com",
    comService: "https://comservice.infinitylearn.com",
    oms: "https://omsapi.infinitylearn.com",
    oneOms: "https://oneomspaymenttracking.infinitylearn.com",
    cms: "https://communityapi.infinitylearn.com",
    oneCms: "https://onecms.infinitylearn.com",
    assetRendering: "https://assetrenderingservice.infinitylearn.com/v1.3",
    masterData: "https://masterdataservice.infinitylearn.com/prod",
    tenantManagement: "https://tenantmanagement.infinitylearn.com",
    newQB: "https://newqbapi.infinitylearn.com",
    assessment: "https://asmapi.infinitylearn.com/v2",
    oneAsm: "https://oneasm.infinitylearn.com",
    doubts: "https://dcapi.infinitylearn.com/apis",
    doubtsDCAPI: "https://dcapi.infinitylearn.com/apis",
    doubtsAI: "https://doubtsai.infinitylearn.com/apis",
    doubtsQB: "https://recsys.infinitylearn.com/api/v1",
    wizklub: "https://wizklub.com",
    peekmind: "https://assessment.peakmind.in",
    peekMindReport:
      "https://azwd5vdqkb.execute-api.ap-south-1.amazonaws.com/qa/cqtest",
    peekmindOnResume:
      "https://ysgxy65qhk.execute-api.ap-south-1.amazonaws.com/prod/cqtest",
    newPeekmindToken: "https://jmfiaoynz9.execute-api.ap-south-1.amazonaws.com",
    newPeekmindQuiz: "https://hr1vg777ii.execute-api.ap-south-1.amazonaws.com",
    learn: "https://learnapilambda.infinitylearn.com",
    liveclass: "https://lcstudentoneapi.infinitylearn.com",
    liveclassSocket: "https://lcwebsocket.infinitylearn.com",
    newasm: "https://newasmapi.infinitylearn.com/",
    eos: "https://eosapi.infinitylearn.com",
    oneApp: "https://oneappapi.infinitylearn.com",
    aina: "https://ainaagent.infinitylearn.com/api/v1",
    uam: "https://api.infinitylearn.com",
    myActivity: "https://myactivityapi.infinitylearn.com",
    dataReport: "https://analytics.infinitylearn.com",
    search: "https://searchapi.infinitylearn.com",
    selflearn: "https://selflearnv2api.infinitylearn.com",
    selflearnWebSocket: "wss://selflearnv2api.infinitylearn.com",
    lsqManagement: "https://lsqmanagementservice.infinitylearn.com",
    lsqService: "https://lsqservice.infinitylearn.com/api/v1",
    testlms: "https://prodslms.ilteacher.com",
  },
};

/**
 * Normalize env string to ModuleApiEnv. Defaults to "production".
 */
export function normalizeModuleEnv(env: string | undefined): ModuleApiEnv {
  if (!env) return "production";
  const normalized = env.toLowerCase();
  if (normalized === "development" || normalized === "dev")
    return "development";
  if (normalized === "staging" || normalized === "stage") return "staging";
  if (normalized === "preprod") return "preprod";
  if (normalized === "production" || normalized === "prod") return "production";
  return "production";
}

/**
 * Get API endpoints for the given environment. Used by modules so they can
 * configure setupMultiApiClient from the consuming app's env (passed as prop).
 */
export function getEndpointsForEnv(env: string | undefined): ApiEndpointsMap {
  const key = normalizeModuleEnv(env);
  return { ...ENV_ENDPOINTS[key] };
}
